import {Headline, HeadlineContainer} from './styles';
import PropTypes from 'prop-types';
import {query} from 'api';

const HomepageHeadline = ({data}) => {
  if (!data) return null;
  return (
    <HeadlineContainer
      style={{
        alignItems: 'start',
        paddingLeft: 20,
      }}>
      <Headline>Bienvenue {data.first_name}</Headline>
    </HeadlineContainer>
  );
};

HomepageHeadline.propTypes = {
  data: PropTypes.object,
};

export default HomepageHeadline |> query('getProfile', {loadingHidden: true});
